import React, {useEffect, useState} from "react";

import cx from "classnames";

import {CutoffTimes} from "@globals/hooks/useCutoffTimes";

import styles from "./OrderCutoffTimeInfo.scss";
import {getTimeRemainingString} from "./getTimeRemainingString";

type OrderCutoffTimeInfoProps = {
  cutoffTimes?: CutoffTimes;
};

export default function OrderCutoffTimeInfo({
  cutoffTimes,
}: OrderCutoffTimeInfoProps): JSX.Element {
  const [deliveryDay, setDeliveryDay] = useState<string>();
  const [cutoffDatetime, setCutoffDatetime] = useState<Date>();
  const [cutoffRemainingText, setCutoffRemainingText] =
    useState<React.ReactNode>();

  const updateCutoffRemainingText = (cutoffDatetime: Date) => {
    const totalSecondsExact =
      (cutoffDatetime.getTime() - new Date().getTime()) / 1000;

    setCutoffRemainingText(
      totalSecondsExact > 86400 ? (
        <>
          Order by <strong>{cutoffTimes?.order_cutoff_day_and_time}</strong>
          <span> for delivery {deliveryDay}</span>
        </>
      ) : (
        <>
          Order within{" "}
          <strong> {getTimeRemainingString(totalSecondsExact)}</strong>
          <span> for delivery {deliveryDay}</span>
        </>
      )
    );
  };

  useEffect(() => {
    if (cutoffTimes) {
      const now = new Date();
      const cutoffDatetimeLocal = new Date();

      const newSeconds =
        cutoffDatetimeLocal.getSeconds() +
        cutoffTimes.order_cutoff_time_remaining;
      cutoffDatetimeLocal.setSeconds(newSeconds);

      setCutoffDatetime(cutoffDatetimeLocal);

      setDeliveryDay(
        cutoffTimes.delivery_day_of_month === now.getDate()
          ? "today"
          : `on ${cutoffTimes.delivery_weekday}`
      );
    }
  }, [cutoffTimes]);

  useEffect(() => {
    if (deliveryDay && cutoffDatetime) {
      // updates the text immediately and then updates it every minute
      updateCutoffRemainingText(cutoffDatetime);
      const interval = setInterval(() => {
        updateCutoffRemainingText(cutoffDatetime);
      }, 1000);

      return () => {
        clearInterval(interval);
      };
    }
  }, [deliveryDay, cutoffDatetime]);

  return (
    <div className={styles.infoContainer}>
      {cutoffTimes && (
        <div className={cx(styles.infoContent, styles.hideMobile)}>
          {cutoffRemainingText}
        </div>
      )}
    </div>
  );
}
